<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Table :columns="column" :data="rowMapped"></Table>
  </div>
</template>
<script>
const numeral = require('numeral');

export default {
  props: {
    column: Array,
    row: Array
  },
  data() {
    return {
      rowMapped: _.map(this.row, (item) => {
        return {
          id: item.id,
          containerNumber: item.container_number ? item.container_number : '-',
          branch: item.branch ? item.branch : '-',
          sumOfVol: item.sum_of_vol ? numeral(item.sum_of_vol).format('0,0.000') : '-',
          sumOfUYAD: item.sum_of_uyad ? numeral(item.sum_of_uyad).format('0,0') : '-',
          pib: item.pib ? numeral(item.pib).format('0,0') : '-',
          notul: item.notul ? numeral(item.notul).format('0,0') : '-',
          opsPort: item.ops_port ? numeral(item.ops_port).format('0,0') : '-',
          trucking: item.trucking ? numeral(item.trucking).format('0,0') : '-',
          daop: item.daop ? numeral(item.daop).format('0,0') : '-',
          demurrage: item.demurrage ? numeral(item.demurrage).format('0,0') : '-',
          reExport: item.re_export ? numeral(item.re_export).format('0,0') : '-',
          shipContGZ: item.ship_cont_gz ? numeral(item.ship_cont_gz).format('0,0') : '-',
          formE: item.form_e ? numeral(item.form_e).format('0,0') : '-',
          ls: item.ls ? numeral(item.ls).format('0,0') : '-',
          omsetDetail: item.omset_detail
        }
      })
    }
  }


};
</script>



// WEBPACK FOOTER //
// TableExpand.vue?1b28cf74